import { FC, ReactNode } from "react";
import { Dialog, DialogContent, DialogTitle } from "src/components/ui/dialog";

interface Props {
	isOpen: boolean;
	onClose: () => void;
	children?: ReactNode;
	ModalControllers: ReactNode;
}

const AlertModal: FC<Props> = ({
	children,
	ModalControllers,
	isOpen,
	onClose
}) => {
	return (
		<Dialog
			open={isOpen}
			onOpenChange={(open) => {
				if (!open) onClose();
			}}
		>
			<DialogContent className="max-w-[481px] p-8" aria-label="Alert">
				<DialogTitle className="sr-only">Alert</DialogTitle>
				<div className="flex flex-col items-center text-center mb-4">
					{children}
				</div>

				<div className="flex flex-row gap-3 mt-8 justify-between">
					{ModalControllers}
				</div>
			</DialogContent>
		</Dialog>
	);
};

export default AlertModal;
